import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { IonicModule } from '@ionic/angular';
import { IncludePipeModule } from '../../../../pipe/includepipe.module';
import { OrderByPipeModule } from '../../../../pipe/orderbypipe.module';
import { PointmainPage } from './pointmain.page';

const routes: Routes = [
  {
    path: '',
    component: PointmainPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,TranslateModule,IncludePipeModule,OrderByPipeModule,
    RouterModule.forChild(routes)
  ],
  declarations: [PointmainPage],
  providers:[TranslatePipe]
})
export class PointmainPageModule {}
